import { Pipe, PipeTransform } from '@angular/core';
import { DataStorageService } from '../services/data-storage.service';

@Pipe({
  name: 'breedTranslate',
  pure: false,
  standalone: false
})
export class BreedTranslatePipe implements PipeTransform {
  constructor(private dataStorageService: DataStorageService) { }

  transform(value: unknown, ...args: unknown[]): unknown {
    const catBreed = this.dataStorageService.catBreeds.find(catBreed => catBreed.id === value);
    if (catBreed) {
      return catBreed.name;
    }

    const dogBreed = this.dataStorageService.dogBreeds.find(dogBreed => dogBreed.id === value);
    if (dogBreed) {
      return dogBreed.name;
    }

    return "UNKNOWN";
  }
}
